import { render, staticRenderFns } from "./temporary-index.vue?vue&type=template&id=2b240197&scoped=true&lang=pug"
import script from "./temporary-index.vue?vue&type=script&lang=js"
export * from "./temporary-index.vue?vue&type=script&lang=js"
import style0 from "./temporary-index.vue?vue&type=style&index=0&id=2b240197&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b240197",
  null
  
)

export default component.exports